/**
 * 큐로 UI 인라인 SVG 아이콘 (이모지 대체 — OS/브라우저/PDF에서 모양 일관).
 * 문자열이라 React(dangerouslySetInnerHTML)와 HTML 리포트 양쪽에서 그대로 사용.
 * currentColor 상속 → 부모 color로 색 지정, width/height 1em → 부모 font-size로 크기.
 */
const svg = inner => `<svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-0.15em">${inner}</svg>`;

export const ICONS = {
    // 문서/리포트
    doc: svg('<path d="M6 2h7l5 5v15H6z"/><path d="M13 2v5h5"/><path d="M9 13h6M9 17h6"/>'),
    // 자물쇠(개인정보)
    lock: svg('<rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>'),
    // 저장(다운로드)
    save: svg('<path d="M12 3v12"/><path d="M8 11l4 4 4-4"/><path d="M5 20h14"/>'),
    // 프린터
    print: svg('<path d="M7 9V3h10v6"/><rect x="4" y="9" width="16" height="8" rx="2"/><path d="M7 14h10v7H7z"/>'),
    // 반짝임(새 기능)
    spark: svg('<path d="M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6z"/><path d="M18 15l.7 1.8L20.5 17.5l-1.8.7L18 20l-.7-1.8L15.5 17.5l1.8-.7z"/>'),
    // AI(칩)
    ai: svg('<rect x="7" y="7" width="10" height="10" rx="2"/><circle cx="12" cy="12" r="2.2"/><path d="M10 3v4M14 3v4M10 17v4M14 17v4M3 10h4M3 14h4M17 10h4M17 14h4"/>'),
    // 코드(파이썬)
    code: svg('<path d="M9 8l-4 4 4 4M15 8l4 4-4 4"/>'),
    // 막대 차트(데이터)
    chart: svg('<path d="M4 20h16"/><path d="M7 20v-7M12 20V6M17 20v-9"/>'),
    // 카메라(웹캠 촬영)
    camera: svg('<rect x="3" y="7" width="18" height="13" rx="2"/><path d="M8 7l1.5-2.5h5L16 7"/><circle cx="12" cy="13.5" r="3.2"/>'),
    // 폴더(업로드/불러오기)
    folder: svg('<path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>'),
    // 폴더+위 화살표(업로드)
    upload: svg('<path d="M3 8a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M12 17v-6M9.5 13l2.5-2.5 2.5 2.5"/>'),
    // 디스크(저장)
    disk: svg('<path d="M5 3h11l3 3v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/><path d="M8 3v5h7V3"/><rect x="8" y="13" width="8" height="6"/>'),
    // 브라우저에 저장(창+아래화살표)
    browser: svg('<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18"/><path d="M12 12v5M9.5 14.5l2.5 2.5 2.5-2.5"/>'),
    // 병합(두 갈래→하나)
    merge: svg('<path d="M6 4v4a4 4 0 0 0 4 4h8"/><path d="M6 20v-4a4 4 0 0 1 4-4"/><path d="M15 9l3 3-3 3"/>'),
    // 휴지통(삭제)
    trash: svg('<path d="M4 7h16"/><path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/><path d="M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13"/>'),
    // 뇌(AI 학습 제목)
    brain: svg('<path d="M9 4a3 3 0 0 0-3 3 3 3 0 0 0-1 5 3 3 0 0 0 2 5 2.5 2.5 0 0 0 5 .5V5.5A2.5 2.5 0 0 0 9 4z"/><path d="M15 4a3 3 0 0 1 3 3 3 3 0 0 1 1 5 3 3 0 0 1-2 5 2.5 2.5 0 0 1-5 .5"/>'),
    // 앱 그리드(큐브로이드 서비스 런처)
    apps: svg('<rect x="4" y="4" width="7" height="7" rx="1.5"/><rect x="13" y="4" width="7" height="7" rx="1.5"/><rect x="4" y="13" width="7" height="7" rx="1.5"/><rect x="13" y="13" width="7" height="7" rx="1.5"/>')
};

// React용: <span> 안에 SVG 삽입. color/fontSize는 style로.
export const iconSpan = (name, style) => ({
    className: 'curo-icon',
    style: Object.assign({display: 'inline-flex', fontSize: '1.1em'}, style || {}),
    dangerouslySetInnerHTML: {__html: ICONS[name] || ''}
});
